import { GrinNotificationTypes } from '@grin-rnd/grin-api-sdk/dist/Enums/Notifications'
import NewMessageBubble from './NewMessageBubble'
import NewScanBubble from './NewScanBubble'
import PatientAssignedBubble from './PatientAssignedBubble'
import NeedsAttentionBubble from './NeedsAttentionBubble'
import PatientJoinedBubble from './PatientJoinedBubble'
import NewLeadBubble from './NewLeadBubble'

export default {
  [GrinNotificationTypes.NewMessage]: NewMessageBubble,
  [GrinNotificationTypes.NewScan]: NewScanBubble,
  [GrinNotificationTypes.UrgentScan]: NewScanBubble,
  [GrinNotificationTypes.PatientAssigned]: PatientAssignedBubble,
  [GrinNotificationTypes.PatientJoined]: PatientJoinedBubble,
  [GrinNotificationTypes.NewRcLead]: NewLeadBubble,
  [GrinNotificationTypes.NewRecordsAppLead]: NewLeadBubble,
  [GrinNotificationTypes.NeedsAttention]: NeedsAttentionBubble
}
